<template>
    <header class="sticky top-0 z-40 bg-white shadow-md">
        <nav class="w-full bg-green-950">
            <div class="mx-auto flex max-w-screen-xl flex-wrap items-center justify-center p-4">
                <p class="m-0 text-sm font-semibold italic text-white dark:text-white">Agarwood Plantations - We Plant, Grow and Harvest</p>
            </div>
        </nav>

        <UContainer class="relative flex items-center justify-start py-4 md:justify-center">
            <NuxtImg format="webp" width="300" class="w-[200px] md:w-[300px]" src="/assets/images/logo.webp" :alt="config.public.company.name" />

            <NuxtImg
                format="webp"
                width="150"
                height="150"
                class="absolute right-2 h-[110px] w-[110px] rotate-6 md:h-[150px] md:w-[150px] lg:right-0"
                src="/assets/images/landing/seal.webp"
                :alt="config.public.company.name" />
        </UContainer>
    </header>
</template>

<script setup>
    const config = useRuntimeConfig()
</script>
